import toPairs from 'lodash/toPairs';

export function getPath(template: string, pathParams: Record<string, string>): string {
  return toPairs(pathParams).reduce(
    (aggregate: string, [key, val]) =>
      aggregate.replace(new RegExp(`{${key}}`, 'gi'), val),
    template,
  );
}
